import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
type Category = {
  id: string;
  title: string;
  description: string;
  image: string;
};
const categories: Category[] = [{
  id: 'alimentation',
  title: 'Voeding',
  description: 'Kruidenierswaren, verse producten en diepvriesproducten — alles voor elke dag, voor de beste prijs.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/2913a658-1d37-4820-8222-adafcc109ad0.jpg'
}, {
  id: 'boisson',
  title: 'Dranken',
  description: 'Sappen, frisdranken, water en een ruime keuze aan dranken in grootverpakkingen.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/6b9094b9-7663-4b69-afd0-40da14098b27.jpg'
}, {
  id: 'maison',
  title: 'Huis & Decoratie',
  description: 'Huishoudelijke artikelen, servies en decoratie om uw interieur compleet te maken.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/18f17a87-9cdc-495c-b496-616fa32f9432.jpg'
}, {
  id: 'electronique',
  title: 'Elektronica',
  description: 'Laptops, accessoires en elektronische apparaten tegen concurrerende prijzen.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/1afd7620-9db5-4262-9698-918a4abe1b08.jpg'
}];
export function Categories() {
  return <section id="categories" className="w-full bg-slate-50 py-20" data-id="element-22" data-mp="2ner7bfshqvs5">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-23" data-mp="2ngltexfi0txt">
        <div className="mx-auto max-w-2xl text-center" data-id="element-24" data-mp="2rh5n1r0v5ff7">
          <h2 className="font-display text-3xl font-extrabold text-ardis-green sm:text-4xl" data-id="element-25" data-mp="2dgbftbpjxki4">
            Onze productcategorieën
          </h2>
          <p className="mt-4 text-slate-600" data-id="element-26" data-mp="2ighdb8ii6184">
            Ontdek ons complete aanbod, samengesteld voor professionals en
            particulieren.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-27" data-mp="gokzttcryhap">
          {categories.map((cat, i) => <motion.a key={cat.id} href={`#${cat.id}`} id={cat.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className="group flex flex-col overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-200 transition-all hover:-translate-y-1 hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-ardis-green" data-id="element-28" data-mp="f7xep4c7mmws" data-mpi={i}>
              <div className="aspect-[4/3] overflow-hidden bg-slate-100" data-id="element-29" data-mp="1gnvaa2w79n1q">
                <img src={cat.image} alt={cat.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-30" data-mp="1gpy8vbbf4oi2" />
              </div>
              <div className="flex flex-1 flex-col p-5" data-id="element-31" data-mp="1o6uqy0sa10he">
                <h3 className="font-display text-lg font-bold text-ardis-green" data-id="element-32" data-mp="1o9gy3zb99dz3">
                  {cat.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600" data-id="element-33" data-mp="1y5aksbiounul">
                  {cat.description}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-ardis-red" data-id="element-34" data-mp="233vju7m7f1hg">
                  Ontdek
                  <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-35" data-mp="273vy9s9azcoi" />
                </span>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}